(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('mbr-countdown')) return;
    const MAP = ['abcdef', 'bc', 'abdeg', 'abcdg', 'bcfg', 'acdfg', 'acdefg', 'abc', 'abcdefg', 'abcdfg'];

    class MbrCountdown extends HTMLElement {
      connectedCallback() {
        this.target = Date.parse(this.dataset.target);
        if (Number.isNaN(this.target)) return;
        this.groups = [...this.querySelectorAll('[data-unit]')];
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      setDigit(seg, n) {
        const on = MAP[n] || '';
        seg.querySelectorAll('i').forEach((i) => i.classList.toggle('on', on.includes(i.classList[0])));
      }
      render(group, value) {
        const min = Number(group.dataset.min) || 2;
        const str = String(value).padStart(min, '0');
        let segs = [...group.querySelectorAll('.mbr-seg')];
        while (segs.length < str.length) {
          const clone = segs[0].cloneNode(true);
          group.prepend(clone);
          segs = [...group.querySelectorAll('.mbr-seg')];
        }
        segs.forEach((seg, idx) => this.setDigit(seg, Number(str[idx])));
      }
      tick() {
        let diff = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
        const values = {
          days: Math.floor(diff / 86400),
          hours: Math.floor((diff % 86400) / 3600),
          minutes: Math.floor((diff % 3600) / 60),
          seconds: diff % 60,
        };
        this.groups.forEach((g) => this.render(g, values[g.dataset.unit]));
        if (diff === 0) {
          clearInterval(this.timer);
          const ended = this.querySelector('.mbr-countdown__ended');
          if (ended) ended.hidden = false;
        }
      }
    }
    customElements.define('mbr-countdown', MbrCountdown);
  })();
  } catch(e) { console.error(e); }
})();

})();
